import shortRedLogo from "@/common/images/icons/logos/logo-short-red.svg";
import fullRedLogo from "@/common/images/icons/logos/logo-full-red.svg";
import shortWhiteLogo from "@/common/images/icons/logos/logo-short-white.svg";
import { routes } from "@/common/utils/routes";
import { Link } from "react-router-dom";
import "./RGLogo.scss";

interface IRGLogoProps {
  isFull?: boolean;
  color?: "white" | "red";
}

export const RGLogo = ({ isFull, color = "red" }: IRGLogoProps) => {
  let logoSrc: string;

  if (color === "white") {
    logoSrc = shortWhiteLogo;
  } else {
    logoSrc = isFull ? fullRedLogo : shortRedLogo;
  }

  return (
    <Link to={routes.home()} className="mainLogo" title="Back to home page" aria-label="Link to home page">
      <img src={logoSrc} alt="Red GIFs" />
    </Link>
  );
};
